'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    Zap,
    Mail,
    TrendingUp,
    Users,
    Bell,
    BarChart3
} from 'lucide-react';

export function MarketingAutomationContent() {
    const t = useTranslations('marketingAutomation');

    const features = [
        {
            icon: Zap,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: Mail,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: TrendingUp,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: Users,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: Bell,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: BarChart3,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    // Get benefits list from translations, ensuring it's always an array
    const benefitsRaw = t.raw('benefits.list');
    const benefits = Array.isArray(benefitsRaw) ? benefitsRaw : (benefitsRaw ? [benefitsRaw] : []);

    return (
        <FeatureDetailContent
            pageKey="marketing-automation"
            translationNamespace="marketingAutomation"
            features={features}
            benefits={benefits}
            ctaIcon={Zap}
            showWhatIsBitcoin={false}
            introImageSrc="/images/features/Marketing-automation.webp"
            introImageAlt={t('intro.imageAlt') || 'Marketing Automation in MLM Software'}
            introParagraphKeys={['paragraph2', 'paragraph3']}
            introSectionHeadingPage="marketing-automation"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About Marketing Automation'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'Marketing Automation'}
            useLocaleContent={true}
        />
    );
}


